import styles from './index.module.scss';
import OnboardingProgress from './onboarding-progress';
import OverviewDetails from './overview-details';

const OverviewCard = () => {
  return (
    <div className={styles.card}>
      <OnboardingProgress progressPercentage={42} />
      <OverviewDetails />
    </div>
  );
};

export default OverviewCard;
